import styled from "styled-components"
import { motion } from "framer-motion"

export const NavModuleStyles = styled.nav`
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    padding: var(--borderSpacing-small) var(--borderSpacing);
    background: var(--background);
    
    &:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 10px;
      left: 0;
      background-image: url('data:image/svg+xml,<svg width="1753" height="41" viewBox="0 0 1753 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.701216 40.8799V8.69392C4.20722 8.69392 7.71319 7.85793 11.2192 7.43993L14.7253 6.60391C20.3349 3.25991 32.9564 3.67794 42.072 2.42394C43.4744 2.42394 44.1757 2.84193 44.1757 3.67793C50.4865 3.67793 55.3948 4.51393 60.3032 5.76793C60.3032 6.60393 60.3032 7.43994 59.602 7.85794C59.602 9.52994 66.614 9.94791 66.614 11.6199C66.614 11.6199 67.3151 11.6199 68.0163 11.6199C72.9247 13.2919 79.2356 14.1279 82.7416 16.2179C90.4548 14.9639 98.168 16.218 105.18 17.054C105.18 17.472 105.18 17.4719 105.18 17.8899C105.18 17.8899 105.18 17.89 105.881 17.472C105.18 16.218 106.582 16.2179 110.088 16.2179C110.088 16.2179 110.088 16.2179 110.79 16.2179C113.594 15.7999 116.399 15.3819 119.905 14.9639C122.71 14.1279 124.814 13.2919 127.618 12.8739C129.722 12.8739 131.826 12.8739 134.63 12.8739C136.734 12.8739 139.539 12.4559 141.642 12.0379C145.148 12.0379 148.654 12.4559 152.16 12.8739C156.368 12.8739 157.77 13.7099 159.172 14.9639C162.678 14.9639 166.184 14.9639 169.69 14.9639H198.44C204.75 13.7099 211.762 12.8739 219.476 13.2919C220.878 13.2919 221.579 13.2919 222.982 13.2919C239.81 14.1279 253.133 10.7839 268.56 9.94791C269.962 9.94791 270.663 9.94791 272.066 9.94791C280.48 10.3659 288.193 11.2019 296.608 11.6199C301.516 12.4559 304.321 14.1279 310.632 14.1279C310.632 14.1279 319.046 13.7099 321.15 12.0379C321.851 12.0379 323.253 12.0379 324.656 12.0379C330.265 13.7099 336.576 12.8739 342.186 12.0379C349.198 12.0379 357.612 13.2919 363.222 10.7839C364.624 10.7839 365.325 10.7839 366.728 10.7839C370.234 10.7839 370.935 10.7839 370.935 12.0379C373.038 12.0379 375.142 12.0379 377.246 12.0379C384.258 12.0379 391.27 12.4559 397.58 11.2019C400.385 11.2019 402.489 12.0379 405.294 12.0379C415.11 12.0379 424.226 10.7839 433.342 9.94791C442.457 9.52991 449.469 11.2019 457.884 12.0379C463.493 10.7839 469.103 10.7839 475.414 10.7839V11.6199C477.517 11.6199 479.621 11.6199 481.023 11.6199C481.724 13.7099 490.139 14.1279 492.242 15.7999C497.852 15.7999 504.163 15.7999 509.772 15.7999C521.693 11.6199 533.613 15.3819 544.832 15.7999C546.936 15.7999 549.741 15.7999 551.844 15.7999C553.948 15.7999 556.753 15.7999 558.856 15.7999C563.064 15.7999 567.972 15.7999 572.179 15.7999C579.892 13.7099 589.008 14.5459 597.422 14.9639C599.526 15.3819 602.331 16.2179 604.434 16.6359C606.538 16.6359 608.642 16.6359 610.745 16.6359C612.849 16.6359 615.654 16.6359 617.757 16.6359C621.263 16.2179 624.769 16.2179 628.275 16.6359V15.7999C633.885 14.1279 640.196 14.1279 645.805 15.7999C659.829 18.7259 673.853 15.7999 687.176 15.7999C694.889 12.0379 703.304 14.5459 711.017 15.7999C711.017 14.1279 714.523 13.2919 718.029 12.4559C719.431 12.4559 720.834 11.6199 721.535 11.2019C725.041 11.2019 728.547 11.2019 732.053 11.2019C735.559 11.2019 739.065 10.3659 742.571 9.94791C747.479 7.85791 754.491 9.11193 760.101 9.11193C760.101 9.11193 760.101 9.52991 760.101 9.94791C760.101 9.94791 759.4 9.11193 760.101 9.11193C767.113 8.27593 773.424 7.85793 777.631 5.76793V4.93191C781.838 4.93191 786.746 4.93191 790.954 4.93191C790.954 4.93191 793.057 4.93191 794.46 4.93191C795.862 5.76791 797.264 7.02194 798.667 7.85794C802.874 7.85794 807.782 7.43994 811.99 7.85794C821.105 6.60394 830.221 5.34993 840.038 4.09593C840.038 2.42393 843.544 1.58794 847.05 0.751938C848.452 0.751938 849.153 0.751938 850.556 0.751938C855.464 1.16994 859.671 2.00594 864.58 2.42394C868.086 2.42394 871.592 1.16994 875.098 2.42394C881.408 2.42394 886.317 3.2599 889.122 4.5139C900.341 3.6779 900.341 7.02192 903.146 8.69392C912.962 9.52992 925.584 9.11191 931.194 13.2919C938.206 12.4559 945.919 11.6199 952.931 13.2919C955.034 13.7099 957.138 14.5459 959.242 15.3819C964.15 15.3819 968.357 15.3819 973.266 15.3819C975.369 15.3819 978.174 15.3819 980.278 15.3819C983.784 14.9639 986.588 14.1279 990.796 14.1279C994.302 13.7099 997.808 13.2919 1001.31 12.8739H1004.82C1011.13 12.8739 1015.34 13.7099 1018.84 14.9639C1024.45 14.9639 1030.76 13.2919 1036.37 14.9639C1042.68 16.6359 1045.49 14.1279 1050.4 14.1279C1051.8 14.1279 1052.5 14.1279 1053.9 14.1279C1053.9 14.1279 1054.6 14.1279 1055.31 14.1279C1055.31 14.1279 1055.31 14.1279 1055.31 13.7099C1058.11 12.0379 1062.32 12.0379 1067.23 12.4559C1070.03 12.4559 1072.84 12.4559 1074.24 13.2919C1075.64 13.2919 1077.04 12.4559 1077.74 12.4559C1081.25 10.7839 1088.26 12.4559 1091.77 11.2019C1099.48 12.0379 1108.6 10.3659 1116.31 12.0379C1118.41 12.0379 1121.22 12.0379 1123.32 12.4559C1130.33 13.7099 1133.84 12.4559 1137.35 10.7839C1142.25 9.52993 1147.86 9.94794 1153.47 9.52994C1156.28 9.52994 1157.68 9.94792 1159.78 10.3659C1163.99 9.52992 1166.1 10.3659 1168.9 11.6199C1173.81 12.4559 1179.42 12.4559 1182.92 14.1279C1182.92 14.1279 1187.13 13.7099 1189.24 13.2919C1191.34 13.2919 1193.44 14.1279 1195.55 14.5459C1196.95 14.5459 1199.05 14.5459 1200.45 14.5459C1202.56 14.5459 1203.96 15.3819 1203.96 16.2179C1205.36 16.2179 1206.06 16.2179 1206.77 16.2179C1207.47 16.2179 1208.87 16.2179 1209.57 16.2179C1209.57 16.2179 1209.57 17.054 1210.27 17.054C1217.28 19.144 1225.7 17.89 1233.41 17.472C1233.41 17.472 1234.11 17.472 1234.81 17.054C1238.32 17.054 1242.53 17.0539 1246.03 16.6359C1250.24 16.6359 1255.15 16.636 1259.36 17.054C1262.86 17.054 1265.67 16.2179 1269.17 15.7999C1271.98 14.5459 1276.18 14.9639 1280.39 14.9639C1287.4 13.2919 1295.12 13.2919 1302.13 14.9639C1312.65 14.9639 1321.76 11.2019 1332.98 14.1279C1335.79 15.3819 1339.99 15.3819 1344.2 14.9639C1344.9 14.9639 1345.6 14.1279 1347.01 13.7099C1351.91 12.4559 1358.22 12.4559 1364.54 12.0379C1372.95 13.7099 1381.36 12.0379 1390.48 12.0379C1392.58 12.0379 1395.39 11.2019 1397.49 10.7839C1398.89 10.3659 1400.3 9.52993 1401.7 9.11193L1411.52 9.94791H1418.53C1422.73 5.76791 1430.45 9.94793 1436.06 9.11193C1443.77 9.11193 1452.19 9.11192 1459.2 10.3659C1466.91 11.6199 1470.42 10.3659 1475.32 9.11193C1478.83 9.11193 1481.64 4.93193 1486.54 9.11193C1490.05 9.94793 1492.85 10.7839 1496.36 11.6199C1498.46 12.0379 1501.27 12.4559 1503.37 12.8739C1510.38 13.2919 1517.4 14.1279 1524.41 14.5459C1527.21 13.2919 1532.12 14.5459 1534.93 13.7099C1536.33 13.7099 1537.03 13.7099 1538.43 13.2919C1543.34 13.7099 1548.95 13.2919 1552.46 14.5459C1553.86 14.5459 1553.86 15.3819 1552.46 15.7999L1555.96 16.6359C1559.47 15.3819 1563.68 16.6359 1567.88 15.7999C1568.58 15.7999 1569.29 15.7999 1570.69 15.7999C1574.9 19.5619 1588.22 19.1439 1595.23 21.2339C1604.35 19.5619 1609.96 23.7419 1618.37 22.4879C1621.88 22.0699 1624.68 22.4879 1626.78 23.3239C1635.9 23.3239 1645.02 23.3239 1654.13 23.7419V24.5779C1655.53 24.5779 1656.94 24.9959 1658.34 25.4139C1659.04 25.4139 1659.74 25.4139 1660.44 25.4139C1666.05 23.7419 1672.36 24.5779 1678.67 24.5779L1682.88 26.6679C1687.79 26.6679 1692 26.6679 1696.9 26.6679C1700.41 26.6679 1704.62 26.6679 1708.12 26.6679C1711.63 26.6679 1715.14 26.6679 1718.64 26.6679C1724.25 27.0859 1730.56 27.9219 1736.87 26.6679C1742.48 25.8319 1748.09 25.8319 1753 27.0859V38.7899H0.701216V40.8799Z" fill="black"/>
</svg>');
      background-size: contain;
      bottom: -8px;
      transform: rotateX(180deg);
      //background-repeat: no-repeat;
    }
    //position: relative;

    .container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
    }

    .social__menu {
      display: none;
    }
    
    @media (min-width: 768px) {
      .social__menu {
        display: block;
      }
    }
    
    @media (min-width: 1024px) {
      //padding-top: 50px;
    }

    @media (min-width: 1440px) {
      //padding-top: 70px;
    }
  }

  .menu {
    background-color: var(--background);
    width: var(--menuWidth);
    transform: translateX(calc(var(--menuWidth) * -1));
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    position: fixed;
    z-index: 99;
    padding: 30px var(--borderSpacing);
    display: flex;
    align-items: center;
  }
`

export const NavTopLevel = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  
  .socials {
    padding: var(--borderSpacing-small) 0;
  }

  > li,
  > li > button {
    text-transform: capitalize;
    font-size: var(--h2);
    font-weight: 700;
    cursor: pointer;
    transition: color 0.3s ease;
    margin-top: 10px;

    a {
      text-decoration: none;
      font-family: var(--fancyFont);
      color: #fff;
      //padding-top: 2px;
    }

    span {
      color: var(--primary);
    }

    &:hover {
      color: var(--primary);
      > a {
        color: var(--primary);
      }
    }
  }

  > li {
    &.open {
      > button > svg {
        transform: rotate(180deg);
      }
    }
  }

  > li > button {
    background-color: transparent;
    padding: 0;
    color: #fff;
    border: none;
    display: flex;
    align-items: center;
  }

  > li > button > svg {
    font-size: 22px;
    margin-left: 6px;
    color: var(--primary);
    transition: transform 0.3s ease;

    @media (min-width: 768px) {
      font-size: 26px;
    }

    @media (min-width: 1024px) {
      font-size: 30px;
    }
  }
`

export const SubNavStyles = styled(motion.ul)`
  padding-left: calc(var(--gap) / 2);
  list-style: none;
  margin: 0;

  > li {
    font-size: var(--h4);
    font-weight: 700;

    &:hover {
      > a {
        color: var(--primary);
      }
    }
  }

  @media (min-width: 1024px) {
    padding-left: var(--gap);
  }

  hr {
    margin-top: 10px;
    margin-bottom: 10px;
  }
`

export const HamburgerStyles = styled(motion.button)`
  background-color: transparent;
  border: none;
  width: 30px;
  height: 30px;
  padding: 0;
  cursor: pointer;
  outline: none;

  &:focus {
    border: none;
    outline: none;
  }

  .bar {
    display: block;
    background-color: #fff;
    height: 2px;
    border-radius: 2px;

    &:nth-of-type(2) {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
`

export const LogoStyles = styled.div`
  position: absolute;
  top: 5px;
  left: 50%;
  transform: translateX(-50%);
  //background: red;
  text-align: center;
  
  a {
    text-decoration: none;
    transition: color 0.3s ease;
  }
  
  .nav__logo {
    width: 65%;
    overflow: visible;
    
    &:before {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 20%;
      transform: translateX(-50%) rotateZ(-45deg);
      //transform: translate(-50%) rotateZ(-20deg) skewX(45deg) scaleY(cos(45deg));
      //bottom: -2%;
      width: 100%;
      height: 100%;
      background: var(--dark-colour);
    }

    @media (min-width: 414px) {
      width: 50%;
    }
    
    @media (min-width: 768px) {
      width: 35%;
    }
  }

  span {
  }

  &:hover,
  &:focus {
    a {

    }
  }
`
